/*
 *   File : subscription.js
 *   Author : https://evoqins.com
 *   Description :  Subscription card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from 'react';

// Components
import { SecondaryButton } from "../Buttons";
import { Chip } from "../Others";

//Style
import Style from "../../Styles/Component/card.module.scss";
import PrimaryButton from '../Buttons/primary-button';
import { useNavigate } from 'react-router-dom';

// Assets
import BasketTag from "../../Assets/Images/Card/alphabasket-tag.svg";
import BasketProTag from "../../Assets/Images/Card/alphabasket-pro-tag.svg";


function SubscriptionCard(props) {

    const navigate = useNavigate();
    // const [showHistory, setShowHistory] = useState(false);

    // Toggle subscription history
    // const _handleShowHistory = () => {
    //     setShowHistory((prev) => !prev);
    // };


    // handle navigate to creator detail page
    const _handleNavigateToCreatorDetail = () => {
        // navigate("/explore/creator-detail");
    };

    // handle navigate to creator detail page
    const _handleNavigateToDetail = () => {
        navigate("/explore/strategy-detail", {
            state: {
                strategy_id: props.product.plan.strategy_id,
                tenant_id: props.product.plan.agreement_template && props.product.plan.agreement_template.creator_id
            }
        });
    };


    return (
        <div className={`${Style.e_alphabasket_card_wrapper}`}>
            <div className='e-bg-white border-radius-16'>
                <div data-type={props.product.strategy_details.basket_type === "alpha-basket" ? "basket" : "basket-pro"}
                    className={`${Style.e_heading_wrapper} text-end  px-4 py-4 position-relative`}>
                    <img src={props.product.strategy_details.basket_type === "alpha-basket" ? BasketTag : BasketProTag}
                        draggable={false}
                        className='position-absolute left--6px top-12px'
                        alt='tag' />
                </div>
                <div className='p-3'>
                    <div className='d-flex align-items-center gap-12px pb-3'>
                        <img src={props.product.strategy_details.strategy_icon}
                            draggable={false}
                            className='w-48px w-32px-res align-self-start'
                            alt='product' />
                        <div>
                            <p className='e-font-14-res mb-1 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px text-decoration-hover-underline'
                                onClick={_handleNavigateToDetail}>
                                {props.product.strategy_details.strategy_name}
                            </p>
                            <p className='e-font-12-res mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px text-decoration-hover-underline'
                                onClick={_handleNavigateToCreatorDetail}>
                                {props.product.created_by}
                            </p>
                        </div>
                        <div className='col-auto ms-auto'>
                            <Chip label={props.product.status}
                                className={props.product.status === 'ACTIVE' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                    'e-text-auro-metal-saurus e-bg-anti-flash-white-light e-border-1px-gainsboro'} />
                        </div>
                    </div>

                    <div className='col'>
                        <div className='row justify-content-between align-items-center mb-3 row-gap-3'>
                            <div className='col-auto'>
                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>

                                    {
                                        props.product.plan.fee_type == "FIXED" ? "Subscription Amount" : "Subscription Percentage"
                                    }
                                </p>
                                <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                    {props.product.plan.fee_text}
                                </p>
                            </div>
                            {/* <div className='col-auto'>
                                <TextButton name="View breakdown"
                                    fontSize="e-font-12"
                                    fontWeight="e-font-weight-500"
                                    onPress={props.handleViewBreakDown} />
                            </div> */}
                        </div>

                        <div className='row justify-content-between align-items-center row-gap-3'>
                            <div className='col-auto'>
                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    Subscribed On
                                </p>
                                <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                    {new Date(props.product.valid_from).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric" }).replace(",", "")}
                                </p>
                            </div>
                            <div className='col-auto'>
                                <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    Subscribed Due Date
                                </p>
                                <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                    {new Date(props.product.valid_to).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric" }).replace(",", "")}
                                </p>
                            </div>
                        </div>

                        {/* Action buttons */}
                        <div className="col">
                            <div className='d-flex flex-column gap-3'>
                                {
                                    props.product.status === "ACTIVE" &&
                                    <SecondaryButton name="Cancel Subscription"
                                        // icon={true}
                                        // iconFirst={false}
                                        // iconName="invoice"
                                        status={props.loading}
                                        className="mt-4 e-letter-spacing-min-point-1px h-48 d-flex align-items-center justify-content-center"
                                        fontSize="e-font-16"
                                        padding="padding-16px-tb"
                                        onPress={props.handleCancelSubscription} />
                                }

                                {/* Subscription history data */}
                                {/* <div className="e-bg-cultured-light px-3 border-radius-8">
                                    <p className='d-flex justify-content-between py-3 align-items-center mb-0 e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px'
                                        onClick={_handleShowHistory}>
                                        Older Subscription History
                                        <Icon icon="drop-down-icon"
                                            className={showHistory ? "e-rotate-180" : ""}
                                            color={Colors.chinese_black}
                                            size="0.875rem" />
                                    </p>
                                    {
                                        showHistory &&
                                        <>
                                            <div className='d-flex align-items-center gap-12px pb-3'>
                                                <img src={require("../../Assets/Images/Card/product-icon.svg").default}
                                                    draggable={false}
                                                    className='w-48px w-32px-res align-self-start'
                                                    alt='product' />
                                                <div>
                                                    <p className='mb-1 e-text-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                        Dividend Compounders - Dummy
                                                    </p>
                                                    <p className='mb-0 e-text-philippine-gray e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                        by Green Portfolio - Dummy
                                                    </p>
                                                </div>
                                                <div className='col-auto ms-auto'>
                                                    <Chip label={props.product.status}
                                                        fontSize="e-font-10"
                                                        className={props.product.status === 'CREATED' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                                            'e-text-auro-metal-saurus e-bg-anti-flash-white-light e-border-1px-gainsboro'} />
                                                </div>
                                            </div>
                                            <div className='row justify-content-between align-items-center mb-3 row-gap-3'>
                                                <div className='col-auto'>
                                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                        Subscribed On
                                                    </p>
                                                    <p className={`e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                                        May 03 2100
                                                    </p>
                                                </div>
                                                <div className='col-auto'>
                                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                                        Subscribed Due Date
                                                    </p>
                                                    <p className={`e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                                        May 03 2100
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div> */}

                                {/*  Subscription renew button*/}
                                {
                                    props.product.status === "IN_ACTIVE" &&
                                    <PrimaryButton
                                        name="Renew"
                                        className="e-letter-spacing-min-point-1px w-100"
                                        fontSize="e-font-16"
                                        padding="padding-16px-tb"
                                        onPress={props.handleRenew}
                                    />
                                }
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubscriptionCard;